import api from "@/config/axios";
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import router from "../router";
import store from "@/store";
import axios from "axios";

const URL_API = process.env.VUE_APP_API_URL + "portal-privado/auth/";
const URL_API_CLI = process.env.VUE_APP_API_URL + "portal-privado/cliente/";

export default {
  login(rut, password) {
    let data = {
      usuario: rut,
      clave: password
    };
    return api.post(URL_API + "login", data);
  },
  renovarToken(minutes) {
    return api.post(URL_API + "renewToken", { minutes });
  },
  setUserLogged(userLogged, start = null) {
    start = start || new Date().getTime();
    let expireTime = new Date(start + userLogged.tokenExp * 1000);
    delete userLogged.imagen_b64;
    let usuarioEncriptado = CryptoJS.AES.encrypt(
      JSON.stringify(userLogged),
      process.env.VUE_APP_CRYPT_KEY
    ).toString();
    Cookies.set("userLoggedLR", usuarioEncriptado, {
      expires: expireTime
    });
    Cookies.set("userLoggedExpired", expireTime);

    store.dispatch("set_timeout");
  },
  async extenderCookie(min) {
    //Agregar validacion en api
    await this.renovarToken(min)
      .then((res) => {
        let { token, tokenExp } = res.data;
        let usuario = this.getUserLogged();
        Cookies.remove("userLoggedLR");
        usuario.token = token;
        usuario.tokenExp = tokenExp;
        let currentExpire = Cookies.get("userLoggedExpired");
        let newExpireTime = new Date(
          new Date(currentExpire).getTime() + min * 60 * 1000
        );
        this.setUserLogged(usuario, newExpireTime);
      })
      .catch((err) => {
        err;
      });
  },
  getUserLogged() {
    let usuarioEncriptado = Cookies.get("userLoggedLR");
    let usuario = CryptoJS.AES.decrypt(
      usuarioEncriptado,
      process.env.VUE_APP_CRYPT_KEY
    ).toString(CryptoJS.enc.Utf8);
    return JSON.parse(usuario);
  },
  getPublicIp() {
    return axios.get("https://api.ipify.org/?format=json");
  },
  async cerrarSesion(redirect = true) {
    Cookies.remove("userLoggedExpired");
    Cookies.remove("userLoggedLR");
    if (redirect) await router.push("/login");
    await store.dispatch("cerrarSesion");
  },
  isAuthenticated() {
    return Cookies.get("userLoggedLR") !== undefined;
  },
  isExpireSet() {
    return Cookies.get("userLoggedExpired") !== undefined;
  },

  userInfo(id_cliente, accion) {
    return api.get(URL_API_CLI + `info_cliente/${id_cliente}/${accion || 1}`);
  },
  info_campanias(id_cliente) {
    return api.get(URL_API_CLI + "info_campanias/" + id_cliente);
  },
  generarClave(data) {
    return api.post(URL_API + "recuperar_clave", data);
  },
  cambiarClave(data) {
    return api.post(URL_API + "cambiar_clave", data);
  },
  cambiarClaveCodigo(data) {
    return api.post(URL_API + "generar_clave", data);
  },
  bitsCliente(form) {
    let data = {
      clien_s_id: form.clien_s_id,
      accion: form.accion
    };
    return api.post(URL_API_CLI + "bits_cliente", data);
  },
  bitsGlobales() {
    let data = {
      accion: 3
    };
    return api.post(URL_API_CLI + "bits_cliente", data);
  },


  async verificarToken(token) {
    try {
      const data = await axios.post(URL_API + "validarToken", {token});
      if(data.data[0].code < 1) return false;
      return true;
    } catch (error) {
      return false
    }
  },
  async enviarNotificacionPreCambioDatos(clien_s_id, tipo_notificacion_cambio_datos, consentimientos, token) {
    return api.post(URL_API_CLI + "enviar-notificacion-pre-cambio-datos", {
      clien_s_id, 
      tipo_notificacion_cambio_datos, 
      consentimientos, 
      ip:(await this.getPublicIp()).data.ip},
      {headers:{'Authorization': `Bearer ${token}`}}
    
    );
  },
  cambiarDatosContactoEnvioCodigoValidacion(data, token) {
    return axios.post(URL_API + "cambiar-datos-contacto-enviar-codigo", data, {headers:{'Authorization': `Bearer ${token}`}})
  },
  cambiarDatosContacto(data) {
    return axios.post(URL_API + "cambiar-datos-contacto", data)
  },
};
